// ConfirmDialogService.ts
/**
 * A global callback function that, when set, will be invoked to display a confirmation dialog.
 * This allows a single ConfirmationDialog component (e.g., at the root of the application)
 * to be imperatively controlled from any part of the application.
 * @type {((config: ConfirmDialogProps) => void) | null}
 */
var confirmDialogCallback = null;
/**
 * Sets the callback function that will be used to display confirmation dialogs.
 * This function should be called once, typically by a global `ConfirmDialog` component,
 * to register itself with the service.
 *
 * @param {(config: ConfirmDialogProps) => void} callback - The function that takes `ConfirmDialogProps`
 * and triggers the display of a confirmation dialog.
 */
export var setConfirmDialogCallback = function (callback) {
    confirmDialogCallback = callback;
};
/**
 * Triggers the display of a confirmation dialog with the given configuration.
 * If a `confirmDialogCallback` has been set (via `setConfirmDialogCallback`),
 * it will be invoked with the provided `config`. Otherwise, a warning is logged to the console.
 *
 * @param {ConfirmDialogProps} config - The configuration object for the confirmation dialog.
 */
export var showConfirmDialog = function (config) {
    if (confirmDialogCallback) {
        confirmDialogCallback(config);
    }
    else {
        console.warn("ConfirmDialog callback not set. Ensure a ConfirmDialog component is mounted and has called setConfirmDialogCallback.");
    }
};
